import { z } from "zod";

export const signupSchema = z
  .object({
    company_name: z
      .string()
      .min(1, "Company name is required")
      .max(255, "Company name must be at most 255 characters"),
    admin_name: z
      .string()
      .min(1, "Admin name is required")
      .max(255, "Admin name must be at most 255 characters"),
    email: z.string().email("Please enter a valid email address"),
    phone: z
      .string()
      .max(20, "Phone number must be at most 20 characters")
      .optional()
      .or(z.literal("")),
    plan_slug: z.string().min(1, "Please select a plan"),
    password: z.string().min(8, "Password must be at least 8 characters"),
    confirmPassword: z.string().min(1, "Please confirm your password"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

export type SignupFormData = z.infer<typeof signupSchema>;
